import { Injectable } from '@angular/core';
import {
  VCPM,
  applyAutoModeDefaults,
  applyAvgConsumptionDefaults,
  migrateHardwareConfigurationStructure as migrateHardwareConfigurationStructurePure,
  migrateToNewWorkloadModalStructure as migrateToNewWorkloadModalStructurePure,
  migrateReusableClusterEntities as migrateReusableClusterEntitiesPure,
  applyProjectMigrations as applyProjectMigrationsPure,
} from 'pcs-domain';

@Injectable({
  providedIn: 'root'
})
export class ProjectMiddlewareService {
  updateSavedProjectWithAutoModeinMgmtandWldDomains(projectData: VCPM.Project) {
    return applyAutoModeDefaults(projectData);
  }

  updateSavedProjectWithAvgMemoryAndCPUConsumptionInRUPOfWorklaodsInWldDomains(projectData: VCPM.Project) {
    return applyAvgConsumptionDefaults(projectData);
  }

  migrateHardwareConfigurationStructure(projectData: VCPM.Project): VCPM.Project {
    return migrateHardwareConfigurationStructurePure(projectData);
  }

  migrateToNewWorkloadModalStructure(projectData: VCPM.Project): VCPM.Project {
    return migrateToNewWorkloadModalStructurePure(projectData);
  }

  migrateReusableClusterEntities(projectData: VCPM.Project): VCPM.Project {
    return migrateReusableClusterEntitiesPure(projectData);
  }

  /**
   * Runs the full backfill/migration chain (all 5 migrations above, in FetchProjectById's
   * existing order) against a single clone. Call this from every store handler that patches
   * `currentProject` from a raw backend response - not just on load - so a save/update response
   * can't leave `currentProject` holding an unmigrated shape until the next full reload.
   */
  applyProjectMigrations(projectData: VCPM.Project): VCPM.Project {
    return applyProjectMigrationsPure(projectData);
  }

  constructor() { }
}
